export default {
    async catchImport(err) {
        console.log('------', err);
        console.log('err.type !== missing || err !== not available=>');
    },
};
